const ONLINE_URL = "https://mydeepsolar.herokuapp.com";

const LOCAL_URL = "http://127.0.0.1:8000";

// create a function to return the base_url based on the environment
const getBaseUrl = () => {
    return ONLINE_URL;
}

export default getBaseUrl;